import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  Stack,
  useDisclosure,
  IconButton,
  Tooltip,
} from '@chakra-ui/react';
import { InfoIcon } from '@chakra-ui/icons';

interface DisclaimerModalProps {
  size?: string;
}

const DisclaimerModal: React.FC<DisclaimerModalProps> = ({ size = "sm" }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Tooltip label="View Full Legal Disclaimer">
        <IconButton
          aria-label="Legal Disclaimer"
          icon={<InfoIcon boxSize={4} />}
          variant="ghost"
          size={size}
          onClick={onOpen}
          color="deebits.red"
          _hover={{ 
            color: 'deebits.red',
            bg: 'red.50' 
          }}
          p={1}
          minW="auto"
          h="auto"
        />
      </Tooltip>

      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="deebits.red">Legal Disclaimer</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text mb={4}>
              This mortgage calculator is provided for illustrative purposes only. The results are estimates based on the information you provide and may not reflect actual mortgage terms or payments. Interest rates, payment terms, and other factors can vary significantly between financial institutions and may change over time.
            </Text>
            <Text fontWeight="bold" mb={2}>We recommend:</Text>
            <Stack spacing={2} pl={4} mb={4}>
              <Text>• Consulting with a qualified mortgage professional for accurate rates and terms</Text>
              <Text>• Verifying all calculations with your financial institution</Text>
              <Text>• Considering that additional costs (property taxes, insurance, etc.) are not included in these calculations</Text>
              <Text>• Understanding that this calculator does not constitute a mortgage approval or guarantee</Text>
            </Stack>
            <Text>
              By using this calculator, you acknowledge that the results are estimates only and should not be used as the sole basis for any financial decisions.
            </Text>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="red" onClick={onClose}>
              I Understand
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default DisclaimerModal; 